// components/common/modal/ModalTitle.tsx
import React from 'react';
import { DialogTitle, DialogTitleProps, IconButton, styled, Typography } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { EntityIcon } from '../Icons';
import { colors } from '@/styles/base/tokens';

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2.5),
    backgroundColor: colors.titleBar,
    color: colors.titleBarText,
    '& .MuiTypography-root': {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        fontWeight: 600,
        color: '#ffffff',
    },
    '& .MuiIconButton-root': {
        color: 'rgba(255, 255, 255, 0.8)',
        '&:hover': {
            color: '#ffffff',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
    },
}));

interface ModalTitleProps extends DialogTitleProps {
    children: React.ReactNode;
    onClose?: () => void;
    icon?: React.ComponentType<SvgIconProps>;
}

export const ModalTitle = ({ children, onClose, icon: Icon, ...props }: ModalTitleProps) => {
    return (
        <StyledDialogTitle {...props}>
            <Typography
                variant="subtitle1"
                component="span"
                sx={{
                    color: 'inherit',
                }}
            >
                {Icon && <Icon sx={{ fontSize: 24 }} />}
                {children}
            </Typography>
            {onClose && (
                <IconButton aria-label="close" onClick={onClose} size="small">
                    <EntityIcon entity={'close'} />
                </IconButton>
            )}
        </StyledDialogTitle>
    );
};
